import { FiltersPayloadType } from '@/features/choice/types';
import { IFilterGridItem } from '@/interfaces/constructor.interfaces';

import { FilterItemsType } from '../types';

import takeExistingFilterValue from './takeExistingFilterValue';

/**
 * Получить значения выбранных фильтров на основе
 * query-параметров
 * @param queryParams {object} Query-параметры
 * @param flattenFilters {object} Данные по фильтрам из настроек приложения
 * @param filters {object} Данные по всем фильтрам
 */
const getFiltersQueryValues = (
  queryParams: Record<string, string>,
  flattenFilters: IFilterGridItem[],
  filters?: FilterItemsType,
) => {
  const result: FiltersPayloadType = {};
  const filtersData = filters?.data;

  if (!filtersData) {
    return result;
  }

  Object.entries(queryParams).forEach(([queryKey, queryValue]) => {
    const filterKey = queryKey;
    const filterValues = filtersData?.[filterKey];
    const filterGridItem = flattenFilters.find(filter => filter.key === filterKey);

    // Получение массива значений query-параметра
    const resolvedQueryValues = queryValue.split('|');

    if (!filterValues || !filterGridItem) {
      return;
    }

    const existingFilterValue = takeExistingFilterValue(
      resolvedQueryValues,
      filterValues,
      filterGridItem,
    );

    if (typeof existingFilterValue !== 'undefined') {
      result[filterGridItem.key] = existingFilterValue;
    }
  });
  return result;
};

export default getFiltersQueryValues;
